import { create } from '../../../utilities/action-helpers';
import * as actions from './actions';

export const setForgotPasswordStatus = create(actions.SET_FORGOT_PASSWORD_STATUS);
export const startForgotPassword = create(actions.START_FORGOT_PASSWORD);